import CatalogueItemsSliderModal from './CatalogueItemsSliderModal';

export default CatalogueItemsSliderModal;
